import { useCan } from "../../../hooks/useCan";

export function useFilterMenu(menuConfig, idProject) {
  const can = useCan();
  const projectPath = idProject !== undefined ? `/projects/${idProject}` : '';

  return Object.entries(menuConfig).reduce((acc, [sectionKey, itemsArray]) => {
    const filteredItems = itemsArray
      .filter(item => !item.check || can(item.check))
      .map(item => ({
        to: projectPath + item.to,
        primary: item.primary,
        disabled: !!item.disabled,
        add: !!item.add
      }));

    if (filteredItems.length > 0) {
      acc[sectionKey] = filteredItems;
    }
    return acc;
  }, {});
}